import IBroker from '~Api/Broker/IBroker';

export function longFormatName(broker: IBroker): string {
    return `${broker.firstName} ${broker.lastName}${broker.companyName ? ` (${broker.companyName})` : ''}`;
}
